import { BackendServiceName } from 'v2/types'
import { createService } from 'v2/shared/services/create-service'
import type { UploaderService } from 'v2/types/api/auth'

const endpoints = {
  file: '/file',
  fetchInvoiceDocument: (filePath: string) => `/billing/file?file_path=${filePath}`,
}

/**
 * Creates an instance of the AuthService.
 * @returns An object with methods for authentication.
 */
const serviceFactory = (): UploaderService => {
  const service = createService('', true, BackendServiceName.uploader, 'v1')
  return {
    uploadFile: (data, config) => service.post(endpoints.file, data, {}, config),
    fetchInvoiceDocument: (args: { file_path: string }) =>
      service.get(endpoints.fetchInvoiceDocument(args.file_path), undefined, {
        responseType: 'blob',
      }),
    // Add more methods here as needed
  }
}

/**
 * A service instance for the authentication API or the Hodor Service (Global)
 * @returns Available methods for authentication.
 */
export const uploaderService = serviceFactory()
